import { useEffect, useState } from "react";

import { useProjectStore } from "@/stores/projectStore";
import { Checkbox } from "@/components/ui/checkbox";
import DocumentRow from "@/components/myProjectsComp/DocumentRow";
import FileImportModal from "@/components/modals/FileImporterModal";
import { useGetAllProjectDocuments } from "@/api/ProjetsApi";
import SmallLoader from "@/components/SmallLoader";

const ProjectDocuments = () => {
  const {
    projects,
    selectedProject,
    selectedProjectDocuments,
    setSelectedProject,
  } = useProjectStore();
  const { getAllProjectDocuments, loading } = useGetAllProjectDocuments();
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);

  const [selectedRows, setSelectedRows] = useState<string[]>([]);

  // Handle header checkbox toggle
  const toggleAllRows = (checked: boolean) => {
    if (checked) {
      if (selectedProjectDocuments) {
        setSelectedRows(selectedProjectDocuments.map((doc: any) => doc.id));
      }
    } else {
      setSelectedRows([]);
    }
  };

  // Handle individual row toggle
  const toggleRow = (id: string, checked: boolean) => {
    setSelectedRows((prev: string[]) =>
      checked ? [...prev, id] : prev.filter((rowId) => rowId !== id)
    );
  };

  // Update the screen height when the window is resized
  useEffect(() => {
    const handleResize = () => {
      setScreenHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const updateSelectedProject = (id: string) => setSelectedProject(id);

    updateSelectedProject(selectedProject?.id || "string");
  }, [projects, selectedProject]);

  useEffect(() => {
    getAllProjectDocuments();
  }, []);

  return (
    <div className="flex-col space-y-2 h-full w-full">
      <div className="grid grid-cols-[500px_2fr_2fr_2fr] p-4 transition">
        <div className="flex items-center space-x-12">
          <Checkbox
            checked={
              selectedRows.length > 0 &&
              selectedRows.length === selectedProjectDocuments?.length
            }
            onCheckedChange={(checked) => toggleAllRows(checked as boolean)}
          />
          <p className="text-sm text-gray-500">Nom de fichier</p>
        </div>
        <div className="text-sm text-gray-500">
          <p>Date de téléchargement</p>
        </div>
        <div className="text-sm text-gray-500">
          <p>Dernière mise ȧ jour</p>
        </div>
        <div className="text-sm text-gray-500">
          <p>Taille du fichier</p>
        </div>
      </div>
      <div
        className={`flex-grow	 overflow-y-auto`}
        style={{ height: `${(screenHeight * (90 / 100)).toString()}` }}
      >
        {loading ? (
          <SmallLoader />
        ) : (
          selectedProjectDocuments?.map((doc, index) => (
            <DocumentRow
              key={index}
              doc={doc}
              isChecked={selectedRows.includes(doc.id)}
              onToggle={toggleRow}
            />
          ))
        )}
      </div>
      <FileImportModal />
    </div>
  );
};

export default ProjectDocuments;
